jQuery(document).ready(function ($) {
    var modal = $('.wc-pao-addons-modal');
    var closeButton = $('.wc-pao-addons-close');
    var button = $('.wc-pao-addons-btn');

    // Open modal on button click
    $(button).click(function(){
        $(modal).fadeIn();
        $('body').addClass('modal-open');
    });

    // Close modal on button click
    $(closeButton).click(function(){
        $(modal).fadeOut();
        $('body').removeClass('modal-open');
    });
});